import React from 'react';

import { flexRender } from '@tanstack/react-table';
import type { Header, SortDirection } from '@tanstack/react-table';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp } from '@fortawesome/pro-duotone-svg-icons';

export const renderTableHeaderCells = <RecordType,>(
  canSort: boolean,
  header: Header<RecordType, unknown>
) => {
  if (canSort)
    return (
      <div className="beewo-table-column-sorters">
        <span className="beewo-table-column-title">
          {flexRender(header.column.columnDef.header, header.getContext())}
        </span>
        <span className="beewo-table-column-sorter">
          <button
            className="beewo-table-sort-btn"
            onClick={header.column.getToggleSortingHandler()}
          >
            <FontAwesomeIcon
              style={{
                // @ts-ignore
                '--fa-primary-color':
                  (header.column.getIsSorted() as SortDirection) === 'asc' ? '#007B94' : '#4F4F4F',
                '--fa-secondary-color':
                  (header.column.getIsSorted() as SortDirection) === 'desc' ? '#007B94' : '#4F4F4F',
                '--fa-secondary-opacity': 1,
              }}
              color="#AAB2B5"
              icon={faSortUp}
            />
          </button>
        </span>
      </div>
    );
  return flexRender(header.column.columnDef.header, header.getContext());
};
